import React from "react";

export function Progress({ value = 0, tone = "actie", height = 8, label, inlineLabel }) {
  const kleur = tone === "positief" ? "var(--positief)" : tone === "inkt" ? "var(--ink)" : "var(--actie)";
  const pct = Math.max(0, Math.min(100, value));
  const binnen = inlineLabel && height >= 18;
  return (
    <div>
      {label ? <div style={{ marginBottom: "var(--ruimte-3)", fontSize: "var(--fs-xs)", color: "var(--text-soft)" }}>{label}</div> : null}
      <div role="progressbar" aria-valuenow={value} aria-valuemin={0} aria-valuemax={100}
        style={{ position: "relative", height, borderRadius: "var(--radius-pil)",
          background: "var(--neutraal-200)", overflow: "hidden" }}>
        <div style={{ height: "100%", width: pct + "%", background: kleur, borderRadius: "var(--radius-pil)",
          transition: "width var(--duur-traag) var(--ease-uit)" }} />
        {binnen ? (
          <span className="cijfer" style={{ position: "absolute", top: 0, bottom: 0, left: "var(--ruimte-5)",
            display: "flex", alignItems: "center", fontSize: "var(--fs-xs)", fontWeight: "var(--fw-semi)",
            color: pct > 18 ? "#fff" : "var(--text-soft)" }}>{inlineLabel}</span>
        ) : null}
      </div>
    </div>
  );
}
